module.exports = __webpack_public_path__ + "media/images/welcom-submit-e31a98b3591b78c0759d69da2040d3ca.png";